




















































import {mixins} from "vue-class-component";
import {Component} from "vue-property-decorator";
import {CommonMixin} from "@/shared/services/mixin";
import {ProvinceStore} from "@/modules/regionsv2/province/store";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import ProvinceSearch from "@/modules/regionsv2/province/components/Search/index.vue";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import {CommonStatus} from "@/enums/status";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import ProvinceAction from "@/modules/regionsv2/province/components/Action/index.vue";
import ProvinceForm from "@/modules/regionsv2/province/Form/index.vue";
import CountryLabelV2 from "@/modules/regionsv2/CountryLabelV2/index.vue";

const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 20
    },
    {
        title: 'Mã tỉnh',
        dataIndex: 'code',
        key: 'code',
        scopedSlots: { customRender: 'code' },
        width: 100
    },
    {
        title: 'Tên tỉnh',
        dataIndex: 'name',
        key: 'name',
        scopedSlots: { customRender: 'name' },
        width: 100
    },
    {
        title: 'Quốc gia',
        dataIndex: 'countryId',
        key: 'countryId',
        scopedSlots: { customRender: 'countryId' },
        width: 100
    },
    {
        title: 'Trạng thái',
        dataIndex: 'status',
        key: 'status',
        scopedSlots: { customRender: 'status' },
        width: 100
    },
    {
        title: 'Thao tác',
        dataIndex: 'id',
        key: 'action',
        scopedSlots: { customRender: 'action' },
        width: 50
    }
]
@Component({
    name: "ProvinceList",
    components: {CountryLabelV2, ProvinceForm, ProvinceAction, EnumSelector, CommonStatusLabel, ProvinceSearch}
})
export default class extends mixins(CommonMixin) {
    columns = columns;
    CommonStatus = CommonStatus;

    get dataSource() {
        return ProvinceStore.provinces;
    }

    get pagination() {
        return {
            current: ProvinceStore.meta.page,
            pageSize: ProvinceStore.meta.limit,
            total: ProvinceStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} tỉnh`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ProvinceStore.paramsChangeProvinceV21({...ProvinceStore.params, page: pagination.current, limit: pagination.pageSize});
    }
}
